import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import axios from "axios";
import ReactTost from "../../ReactTost";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AddPlan = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [planTitle, setPlanTitle] = useState("Add plan");
  const [name, setName] = useState();
  const [price, setPrice] = useState("0");
  const [priceDisable, setPriceDisable] = useState(false);
  const [duration, setDuration] = useState();
  const [maxBot, setMaxBotCount] = useState("0");
  const [maxFileCount, ] = useState("0");
  const [storage, setMaxFileSize] = useState("0");

  const [maxMessage, setMaxQuestionCount] = useState("0");
  const [, setIsCustom] = useState(false);
  const [position, setPosition] = useState(0);

  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;

  function savePlan(e) {
    e.preventDefault();
    if (name && duration && maxBot && maxFileCount && storage && maxMessage) {
      if (id) {
        axios
          .patch(
            `${API_URL}/${API_VERSION}/plan/${id}`,
            {
              name,
              // price,
              duration,
              maxBot: maxBot.toString(),
              storage: storage.toString(),
              maxMessage: maxMessage.toString(),
              position,
            },

            {
              headers: {
                accept: "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          )
          .then((response) => {
            setType("Success");
            setMessage(t("Plan is updated."));
            setShowAlert(true);
            setTimeout(() => {
              navigate("/admin/plans-list");
            }, 3000);
          })
          .catch((error) => {
            setType("Danger");
            setMessage(
              error.response.data.message
                ? error.response.data.message
                : t("Something went to wrong.")
            );
            setShowAlert(true);
          });
      } else {
        axios
          .post(
            `${API_URL}/${API_VERSION}/plan`,
            {
              name,
              price,
              duration,
              maxBot,

              storage,

              maxMessage,
              position,
            },
            {
              headers: {
                accept: "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          )
          .then((response) => {
            setType("Success");
            setMessage(t("Plan is added."));
            setShowAlert(true);
            setTimeout(() => {
              navigate("/admin/plans-list");
            }, 3000);
          })
          .catch((error) => {
            setType("Danger");
            setMessage(
              error.response.data.message
                ? error.response.data.message
                : t("Something went to wrong.")
            );
            setShowAlert(true);
          });
      }
    }
  }

  useEffect(() => {
    if (id) {
      axios
        .get(`${API_URL}/${API_VERSION}/plan/${id}`, {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          setName(response.data.name);
          setPrice(response.data.price);
          setPriceDisable(true);
          setDuration(response.data.duration);
          setMaxBotCount(response.data.maxBot);
          setMaxFileSize(response.data.storage);

          setMaxQuestionCount(response.data.maxMessage);
          setIsCustom(response.data.isCustom);
          setPosition(response.data.position);
          setPlanTitle(t("Edit plan"));
        })
        .catch((error) => { });
    }
  }, [id, API_URL, API_VERSION]);

  return (
    <>
      <section className="client_main">
        <ReactTost
          onHide={() => {
            setShowAlert(false);
            setType("");
            setMessage("");
          }}
          alertClass={type}
          alertMessage={message}
          alertDo={showAlert}
        />
        <Container>
          <Row className="justify-content-center">
            <Col xxl={6} xl={6} lg={8} md={10} sm={12}>
              <div className="boxwrap">
                <h1>{planTitle}</h1>
                <p className="mb-3">{t("Enter the information for your plan.")}</p>
                <Row>
                  <Col md={12}>
                    <div className="form-group mb-3">
                      <label htmlFor="">{t("Title")}</label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        placeholder="Enter title here"
                        value={name}
                        onChange={(event) => setName(event.target.value)}
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="form-group mb-3">
                      <label htmlFor="">{t("Position")}</label>
                      <input
                        type="number"
                        className="form-control"
                        id="position"
                        name="position"
                        placeholder=""
                        value={position}
                        onChange={(event) => setPosition(event.target.value)}
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="form-group mb-3">
                      <label htmlFor="">{t("Price")}</label>
                      <input
                        disabled={priceDisable}
                        type="number"
                        className="form-control"
                        id="price"
                        name="price"
                        placeholder="Enter price here"
                        value={price}
                        onChange={(event) => setPrice(event.target.value)}
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="form-group mb-3">
                      <label htmlFor="">{t("Frequency")}</label>
                      <select
                        className="form-select"
                        onChange={(event) => setDuration(event.target.value)}
                        value={duration}
                      >
                        <option selected>{t("Choose frequency")}</option>
                        <option value="month">{t("Monthly")}</option>
                        <option value="year">{t("Yearly")}</option>
                      </select>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="form-group mb-3">
                      <label htmlFor="">{t("Bot limit")}</label>
                      <input
                        type="number"
                        className="form-control"
                        id="botLimit"
                        name="botLimit"
                        placeholder="Bot limit"
                        value={maxBot}
                        onChange={(event) => setMaxBotCount(event.target.value)}
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="form-group mb-3">
                      <label htmlFor="">{t("Question limit")}</label>
                      <input
                        type="number"
                        className="form-control"
                        id="QuestionLimit"
                        name="QuestionLimit"
                        placeholder="Question limit"
                        value={maxMessage}
                        onChange={(event) =>
                          setMaxQuestionCount(event.target.value)
                        }
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="form-group mb-3">
                      <label htmlFor="">{t("Storage Size")}</label>
                      <input
                        type="number"
                        className="form-control"
                        id="fileSize"
                        name="fileSize"
                        placeholder="Storage size limit"
                        value={storage}
                        onChange={(event) => setMaxFileSize(event.target.value)}
                      />
                    </div>
                  </Col>
                </Row>
                <div className="text-start mb-4">
                  <input
                    type="button"
                    value={planTitle}
                    className="button px-4 py-3"
                    onClick={(e) => savePlan(e)}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default AddPlan;
